<template lang="pug">
  //- Sin etiquetas → nada: que la ficha técnica no la mencione no prueba que
  //- el producto no la tenga, así que nunca se muestra un "no tiene".
  section.sll(v-if="labels.length || certifications.length")
    .sll-head
      bk-sustainability-badge(v-if="labels.length" :labels="labels")
      span.sll-title #[translate Certificados y etiquetas]
    //- Una sola fila que se parte: etiquetas del producto y, tras el
    //- separador "Del fabricante", las certificaciones del fabricante.
    ul.sll-grid
      li.sll-item(v-for="l in labels" :key="'label-' + l.id")
        .sll-logo(v-if="l.image_url && !brokenLogos['label-' + l.id]")
          img(:src="l.image_url" :alt="l.name" @error="setBroken('label-' + l.id)")
        .sll-name {{ l.name }}
      template(v-if="certifications.length")
        li.sll-group-label(
          :class="{'sll-group-label--after': labels.length}"
          :title="$gettext('Certifican la empresa o la fábrica, no este producto')"
        ) #[translate Del fabricante:]
        li.sll-item(v-for="c in certifications" :key="'mfr-' + c.id")
          .sll-logo(v-if="c.image_url && !brokenLogos['mfr-' + c.id]")
            img(:src="c.image_url" :alt="c.name" @error="setBroken('mfr-' + c.id)")
          .sll-name {{ c.name }}
</template>

<script>
// Sección de la ficha: una tarjeta por etiqueta, con el logo si lo tiene y el
// nombre siempre (también si el logo no carga).
// Datos: extra_info.sustainability.labels / .manufacturer_certifications,
// cada uno { id, name, description, website_url, image_url }.
// Diseño portado de NEW-ECOMMERCE-FRONTEND (commits 70c41ac y 7da69fe).
import BkSustainabilityBadge from '@/components/catalog/Sustainability-Label-Badge.vue'

export default {
  name: 'SustainabilityLabelList',
  components: { BkSustainabilityBadge },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    // Certificaciones del fabricante (ISO 14001, EMAS…): aparte y más discretas,
    // nunca en la bola: certifican la empresa, no el producto.
    certifications: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      brokenLogos: {}
    }
  },
  methods: {
    setBroken (key) {
      this.$set(this.brokenLogos, key, true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sll{
    margin-bottom: 24px;
  }

  .sll-head{
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .slb{
      margin-right: 8px;
    }
  }

  .sll-title{
    font-size: 11px;
    font-weight: $medium;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: #8a8f96;
  }

  .sll-grid{
    list-style: none;
    margin: 0;
    padding: 0;
    // Del tamaño de su contenido, no estiradas a una columna.
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }

  .sll-item{
    display: flex;
    align-items: center;
    min-height: 38px;
    padding: 5px 12px;
    // Sin borde: son información, no botones.
    background: #F6F6F6;
    @include roundAll(4);
  }

  .sll-logo{
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .sll-group-label{
    display: flex;
    align-items: center;
    font-size: 11.5px;
    color: #8a8f96;
    cursor: default;

    // Separador de las etiquetas del producto cuando hay de los dos grupos.
    &--after{
      margin-left: 4px;
      padding-left: 10px;
      border-left: 1px solid #d5d8dc;
    }
  }

  .sll-name{
    min-width: 0;
    font-size: 12.5px;
    font-weight: $medium;
    color: #494f58;
    line-height: 1.3;
  }
</style>
